module.exports = "../../../../platform/assets/pageMainIcon/icon-riqi-2-yellow.svg";